<template>
  <div
    class="table-search-container"
  >
    状态：
    <a-select
      style="width:150px"
      class="select-container"
      placeholder="请选择状态"
      @change="value => $emit('onChangeStatus', value)"
    >
      <a-select-option
        v-for="item in statusData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    时间：
    <a-date-picker
      @change="value=>$emit('onStartTime',value)"
    />
    <a-date-picker
      class="select-container"
      @change="value=>$emit('onEndTime',value)"
    />
    <a-input-search
      class="select-container"
      placeholder="请输入搜索内容"
      style="width:200px;"
      @search="value => $emit('onSearch', value)"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusData: [
        {id: -1, name: '全部'},
        {id: 0, name: '待审核'},
        {id: 1, name: '待打款'},
        {id: 2, name: '已置顶'},
        {id: 3, name: '不通过'},
        {id: 4, name: '已打款'},
      ],
    };
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
  .select-container{
    margin-left:10px;
  }
}
</style>
